type FooterCTAProps = {
  currentStep: 1 | 2 | 3 | 4 | 5;
  visible: boolean;
};

const STEP_CTAS: Record<1 | 2 | 3 | 4 | 5, { label: string; href: string } | null> = {
  1: { label: 'Continue → Choose Scenario', href: '#scenario-library' },
  2: { label: 'Continue → Add Event Marker', href: '#event-marker' },
  3: { label: 'Continue → Run Correlation', href: '#event-correlation' },
  4: { label: 'Continue → Create Signal', href: '#correlation-results' },
  5: { label: 'Continue → Export', href: '#correlation-results' }
};

export function FooterCTA({ currentStep, visible }: FooterCTAProps) {
  if (!visible) return null;
  const cta = STEP_CTAS[currentStep];
  if (!cta) return null;

  return (
    <aside className="footer-cta-bar" role="region" aria-label="Workflow continue action">
      <span className="footer-cta-step">Step {currentStep} of 5</span>
      <a className="button primary footer-cta-button" href={cta.href}>{cta.label}</a>
    </aside>
  );
}
